import { render, staticRenderFns } from "./SetUpLearningFacilityForm.vue?vue&type=template&id=465b08f4&scoped=true"
import script from "./SetUpLearningFacilityForm.vue?vue&type=script&lang=js"
export * from "./SetUpLearningFacilityForm.vue?vue&type=script&lang=js"
import style0 from "./SetUpLearningFacilityForm.vue?vue&type=style&index=0&id=465b08f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465b08f4",
  null
  
)

export default component.exports